import { CheckAvailabilityViewModel } from '@api/v3';
import { DEFAULT_DATE_FORMAT, formatISOToDate } from '@utils/dateUtil';

export const getDateStatus = (
  dates?: CheckAvailabilityViewModel,
  date?: string
) => {
  return (
    dates?.availabilityList?.find(
      (item) => formatISOToDate(item.date, DEFAULT_DATE_FORMAT) === date
    )?.roomStatus ?? undefined
  );
};
